import React, { FC } from 'react'

import { Summary } from 'features/identityCheck/components/Summary'
import { Button } from 'ui/designSystem/Button/Button'
import { PageWithHeader } from 'ui/pages/PageWithHeader'

type Props = {
  birthDate?: string | null
  firstName?: string | null
  lastName?: string | null
  address?: string | null
  status?: string | null
  onValidate: VoidFunction
}

export const EduconnectValidationPageButtonName = 'Continuer'

export const EduconnectValidationPage: FC<Props> = ({
  birthDate,
  firstName,
  lastName,
  address,
  status,
  onValidate,
}) => {
  return (
    <PageWithHeader
      shouldLimitWidth
      title="Informations personnelles"
      scrollChildren={
        <Summary
          title="Voici les informations que nous avons récupérées. Vérifie qu’elles sont correctes."
          data={[
            { title: 'Ton prénom', testID: 'validation-first-name', value: firstName },
            { title: 'Ton nom de famille', testID: 'validation-name', value: lastName },
            { title: 'Adresse', value: address },
            { title: 'Ville de résidence', testID: 'validation-birth-date', value: birthDate },
            { title: 'Statut', value: status },
          ]}
        />
      }
      fixedBottomChildren={
        <Button type="submit" wording={EduconnectValidationPageButtonName} onPress={onValidate} />
      }
    />
  )
}
